import React, { useEffect, useState } from 'react';
import { base_url } from '../../AppConfig';
import { apis } from '../../services/Api';
import { setToken } from '../../services/Auth';
import { css } from "@emotion/react";
import { ScaleLoader } from "react-spinners";
import './signInstyle.css'


// Can be a string as well. Need to ensure each key-value pair ends with ;
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

function SignIn(props) {
    let [loading, setLoading] = useState(true);
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.href);
        const code = urlParams.get('code');
        // let hashParams = getHashParameters();
        // //console.log(hashParams);
        // if (hashParams["error"]) {

        // } else
        if (code) {
            //console.log(code);
            apis.getToken(code).then((result) => {
                //console.log(result);
                setToken(result);
                props.history.push({
                    pathname: "/"
                });
            }).catch((e) => {
                //console.log(e);
            })
        } else {
            // Unexpected condition: hash does not contain error or access_token parameter
            setLoading(false);
        }
    }, []);

    const onSignIn = () => {
        // //console.log("sign in page");
        // props.history.push({
        //     pathname: "/sign-in/sign-in-start"
        // });
        let location = window.location.href;
        let queryParams = {
            client_id: "51deaf95-d7fa-4459-956c-a62664b57877",
            redirect_uri: `${location}`,
            state: "prime_auth",
            scope: "learner:read,learner:write",
            response_type: "CODE"
        };

        let authorizeEndpoint = `${base_url}/oauth/o/authorize?logoutAfterAuthorize=true&account=107442&${toQueryString(queryParams)}`;
        window.location.assign(authorizeEndpoint);
    }


    return (
        <React.Fragment>
            <div className='signin-block'>
                <div className='main-block'>
                    <div className='container'>
                        <div className="login-block-txt">
                            <h1 className="headding-title">Welcome to Harbinger Learning!  <span className=''>Learn Anytime, Learn Anywhere </span></h1>
                            <div className='login-text'>
                                <p>Build your skills with our online courses.</p>
                            </div>
                            {!loading ?
                                <button type="button" className=" fill" onClick={onSignIn}>Login with Adobe</button> :
                                <button className=" fill">
                                    <ScaleLoader color={"#ffffff"} loading={true} css={override} height={10} />
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <footer>
                <div className='container'>
                    <div className='row footer-block'>
                        <div className='footer-txt col'>
                            Powered by Adobe Captivate Prime
                        </div>
                        <div className='col foolter-link'>
                            <a className='link' href='https://harbingergroup.com/contact-us/' target="_blank">Help</a>
                            <span className='small-separator'></span>
                            <a className='link' href='mailto:venkatesh.c@harbingergroup.com' target="_blank">Contact Admin</a>
                        </div>
                    </div>

                </div>
            </footer>
        </React.Fragment >
    );
}

// Parse hash parameters into key-value pairs
export function getHashParameters() {
    var search = window.location.search.substring(1);
    return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
}

export function toQueryString(queryParams) {
    let encodedQueryParams = [];
    for (let key in queryParams) {
        encodedQueryParams.push(key + "=" + encodeURIComponent(queryParams[key]));
    }
    return encodedQueryParams.join("&");
}

export default SignIn;